import { ChakraFlex, FormLabel, RadioV2 } from '@equip.health/ui';

import {
  EDIT_SCOPE_LABEL,
  RecurringAppointmentUpdateOption,
} from '~/lib/constants/calendar.constants';

export interface EditRecurrenceStepProps {
  onOptionChange: (value: RecurringAppointmentUpdateOption) => void;
  id: string;
  shouldEditAllAppointments: RecurringAppointmentUpdateOption;
}

const EditRecurrenceStep = ({
  id,
  shouldEditAllAppointments,
  onOptionChange,
}: EditRecurrenceStepProps) => {
  return (
    <ChakraFlex direction="column" gap="12px" marginTop="6px">
      <FormLabel
        id={`${id}__cancel-scope-label`}
        label={EDIT_SCOPE_LABEL}
        shouldShowAsteriskWhenRequired
      />
      <ChakraFlex direction="column" gap="18px">
        {Object.values(RecurringAppointmentUpdateOption).map((option) => (
          <RadioV2
            id={`${id}__${option}`}
            isChecked={shouldEditAllAppointments === option}
            key={option}
            label={option}
            onChange={() => onOptionChange(option)}
            size="md"
          />
        ))}
      </ChakraFlex>
    </ChakraFlex>
  );
};

export default EditRecurrenceStep;
